import { formatCurrency as externalFormatCurrency } from "~/utils/currencyFormatter";
import { strictIsNonNull } from "~/utils/reducers";

export function makeFormatCurrency(currency: string) {
  return (amount: number | undefined | null) => {
    return strictIsNonNull(amount) ? externalFormatCurrency(amount, currency) : "-";
  };
}
